import type {ImageSourcePropType} from 'react-native';

const map: Record<string, ImageSourcePropType> = {
  renner: require('./renner.png'),
  decolar: require('./decolar.png'),
  'casas bahia': require('./casas-bahia.png'),
  'casas-bahia': require('./casas-bahia.png'),
  nike: require('./nike.png'),
  netshoes: require('./netshoes.jpg'),
  vivara: require('./vivara.png'),
  riachuelo: require('./riachuelo.png'),
  electrolux: require('./electrolux.png'),
  'faculdade unyleya': require('./unyleya.png'),
  'movida aluguel de carros': require('./movida.png'),
};

export function getDestaqueImage(nome: string): ImageSourcePropType | null {
  return map[nome.trim().toLowerCase()] ?? null;
}
